import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import {
  BaseComboboxInputProps,
  ComboboxInput,
} from "@/lib/Components/Form/Inputs/ComboboxInput";
import {
  IncidentWorkOrderOption,
  incidentWorkOrderOptionsQuery,
} from "@/app/Incidents/GraphQL/incidentWorkOrderOptionsQuery";
import { incidentWorkOrderOptionQuery } from "@/app/Incidents/GraphQL/incidentWorkOrderOptionQuery";
import { Highlighter } from "@/lib/Components/Highlighter";

export function IncidentWorkOrderInput(
  props: BaseComboboxInputProps<
    ResultOf<typeof incidentWorkOrderOptionsQuery>,
    VariablesOf<typeof incidentWorkOrderOptionsQuery>,
    IncidentWorkOrderOption,
    ResultOf<typeof incidentWorkOrderOptionQuery>,
    VariablesOf<typeof incidentWorkOrderOptionQuery>
  >,
) {
  return (
    <ComboboxInput
      document={incidentWorkOrderOptionsQuery}
      accessor={(res) => res.workOrders.data}
      getQueryVariables={(search) => ({
        first: 10,
        page: 1,
        search,
      })}
      recordDocument={incidentWorkOrderOptionQuery}
      recordAccessor={(res) => res.workOrder!}
      getKey={(workOrder) => workOrder.id}
      getInputNode={(workOrder) => workOrder.reference}
      getViewNode={(workOrder) => workOrder?.reference ?? "--"}
      getListItemNode={(workOrder, search) => (
        <div>
          <div>
            <Highlighter searchString={search}>
              {workOrder.reference}
            </Highlighter>
          </div>
          <div className="text-muted-foreground text-xs">
            {workOrder.supplier.name} · {workOrder.departureAddress.city} →{" "}
            {workOrder.deliveryAddress.city}
          </div>
        </div>
      )}
      {...props}
    />
  );
}
